export const baseUrl = process.env.REACT_APP_BASE_URL;

// export const baseUrl = 'http://localhost:8080';